export default __webpack_public_path__ + "static/screeny-150-storm-2-d0095733f113160a97ef085a11489789.jpg";